import React, { useEffect, useMemo, useRef, useState } from 'react';
import * as THREE from '../../../../../dist/three.module.js';
import { fmesh, fmeshPoints } from '../../../../core/globalVariables.js';
import Chart from 'chart.js/auto';
import zoomPlugin from 'chartjs-plugin-zoom';
import 'chartjs-adapter-date-fns';
import axios from 'axios';
import mapboxgl from 'mapbox-gl';

Chart.register(zoomPlugin);

const DynamicPieChart = ({
    value,
    unit,
    colorMap = {},
    height = 160,
}) => {
    const canvasRef = useRef(null);
    const chartRef = useRef(null);

    const defaultColors = [
        "#29645D", // --darkgreen
        "#073028", // --darkestgreen
        "#F2F1F6", // --lightgrey
        "#E6E4ED", // --hovergrey
        "#A9A8AA", // --textgrey
        "#AAAAAB", // --midgrey
        "#4C5758", // --slategrey
        "#073029", // --text2Color
    ];

    useEffect(() => {
        if (!canvasRef.current || !value) return;

        const labels = Object.keys(value);
        const dataValues = Object.values(value);

        const backgroundColors = labels.map(
            (label, index) => defaultColors[index % defaultColors.length]
        );

        if (chartRef.current) {
            chartRef.current.destroy();
        }

        chartRef.current = new Chart(canvasRef.current, {
            type: "pie",
            data: {
                labels,
                datasets: [
                    {
                        data: dataValues,
                        backgroundColor: backgroundColors,
                        borderWidth: 0,
                        hoverOffset: 4,
                    },
                ],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                animation: false,
                plugins: {
                    legend: {
                        display: false,
                    },
                    tooltip: {
                        callbacks: {
                            label: (ctx) => {
                                const label = ctx.label;
                                const val = ctx.raw;
                                return `${label}: ${val.toLocaleString()}${unit ? ` ${unit}` : ""}`;
                            },
                        },
                    },
                },
            },
        });

        return () => {
            if (chartRef.current) {
                chartRef.current.destroy();
            }
        };
    }, [value, unit, colorMap]);

    return (
        <div style={{ height }}>
            <canvas ref={canvasRef} />
        </div>
    );
};

export default DynamicPieChart